export default function getLocalization(stringKey) {
  if (typeof window.jr_red_screenReaderText === 'undefined' || typeof window.jr_red_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.jr_red_screenReaderText[stringKey];
}
